// extracted by mini-css-extract-plugin
export default {"countBadge":"tabLabel_countBadge__5AvKh","countText":"tabLabel_countText__h9+Gl"};